import React from 'react'

import './subCover.css'

const SubCover = ({handleCloseCover}: any) => {
  return (
    <div className="sub-cover active" onClick={handleCloseCover}></div>
  )
}

export default SubCover